<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.key"
      :value="true"
      :width="dialog.width"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :persistent="dialog.persistent"
      :retain-focus="false"
      scrollable
      @click:outside="closeOutside(dialog)"
    >
      <v-card>
        <v-card-title class="py-2 px-3 grey lighten-4">
          <v-icon left color="indigo">mdi-gesture-tap-button</v-icon>
          <span class="text-subtitle-1 font-weight-medium">{{ dialog.title }}</span>
          <v-spacer />
          <v-btn icon @click="close(dialog.key)"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-2">
          <ActionEditor
            :module-id="dialog.moduleId"
            :action-id="dialog.actionId"
            :context-key="dialog.key"
            embedded
            @saved="saved(dialog, $event)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ActionEditor from './editAction.vue'
import { actionEditorDialogs, closeActionEditor, notifyActionSaved } from './navigation'

export default {
  name: 'ActionEditorDialogHost',
  components: { ActionEditor },
  computed: {
    dialogs() {
      return actionEditorDialogs.items
    },
  },
  methods: {
    close(key) {
      closeActionEditor(key)
    },
    closeOutside(dialog) {
      if (!dialog.persistent) this.close(dialog.key)
    },
    saved(dialog, action) {
      notifyActionSaved(dialog.key, action)
      this.close(dialog.key)
    },
  },
}
</script>
